<template>
  <MultiSelect
    :label="$i18n('interface.novo_filtro.forma_pagamento')"
    :campos="campos"
    :filtro="filtro"
    :filtro_id="filtro.filtro"
    :path="path"
    @atualizar="onAtualizar"
  />
</template>
<script>
import { computed, toRef } from 'vue';
import MultiSelect from '../../components/MultiSelect.vue';
import { useFiltroMultiSelect } from '../../composables/useFiltroMultiSelect';

export default {
  components: { MultiSelect },
  props: {
    filtro: { type: Object, required: true },
    path: { type: String, required: true },
  },
  setup(props) {
    const campos = computed(() => {
      const items = props.filtro?.parametros?.items || [];
      return items.map(item => ({ id: item.id, name: item.name }));
    });
    const { onAtualizar } = useFiltroMultiSelect({
      filtro: toRef(props, 'filtro'),
      path: toRef(props, 'path'),
    });
    return { campos, onAtualizar };
  },
}
</script>
